import PropTypes from "prop-types";
import Input from "react-input-mask";
import cns from "classnames";
import {
  formInput,
  formLabel,
  validationError,
} from "@/assets/styles/common.module.scss";
import { memo } from "react";

const LabelMaskInput = ({
  lblTxt,
  inputNm,
  parentClass = "",
  childClass = "",
  value,
  onChange,
  error = "",
  refreshErrors,
  mask,
  maskChar = null,
  ...restProps
}) => {
  // TODO: remove handleKeyPress [Doesn't work on android mobile]
  const handleKeyPress = (e) => {
    const key = e.keyCode || e.which;
    if (maskChar) {
      if (String.fromCharCode(key) === maskChar) {
        e.returnValue = false;
        if (e.preventDefault) e.preventDefault();
      }
    }
  };

  const handleBlur = () => {
    refreshErrors(inputNm);
  };

  return (
    <section
      className={`d-flex flex-column flex-column-reverse ${parentClass}`}
    >
      <aside className={cns(formLabel, validationError)}>
        {error || ""}&nbsp;
      </aside>
      <Input
        className={cns(formInput, "rounded-pill", childClass)}
        type="text"
        name={inputNm}
        id={inputNm}
        mask={mask}
        maskChar={maskChar}
        autoComplete="none"
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
        onKeyPress={handleKeyPress}
        {...restProps}
      />
      <label htmlFor={inputNm} className={cns("d-block", formLabel)}>
        {lblTxt}
      </label>
    </section>
  );
};

LabelMaskInput.propTypes = {
  childClass: PropTypes.string,
  error: PropTypes.string,
  inputNm: PropTypes.any,
  lblTxt: PropTypes.any,
  mask: PropTypes.any,
  maskChar: PropTypes.any,
  onChange: PropTypes.any,
  parentClass: PropTypes.string,
  refreshErrors: PropTypes.func,
  value: PropTypes.any,
};

function arePropsEqual(prevProp, nextProp) {
  return (
    prevProp.value === nextProp.value &&
    prevProp.onChange === nextProp.onChange &&
    prevProp.error === nextProp.error &&
    prevProp.mask === nextProp.mask
  );
}

export default memo(LabelMaskInput, arePropsEqual);
